// extracted by mini-css-extract-plugin
module.exports = {"availability":"Availability-module--availability--25cZE","available":"Availability-module--available--11yWv"};